/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_File_UploadInputs */

const en_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel file upload`)
};

const fr_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler le téléversement du fichier`)
};

const de_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei-Upload abbrechen`)
};

const it_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla caricamento file`)
};

const ru_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить загрузку файла`)
};

const es_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar la carga de archivos`)
};

const zh_cn2_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消文件上传`)
};

const ja_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのアップロードをキャンセル`)
};

const hi_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल अपलोड रद्द करें`)
};

const pt_pt2_cancel_file_upload = /** @type {(inputs: Cancel_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar envio de arquivo`)
};

/**
* | output |
* | --- |
* | "Cancel file upload" |
*
* @param {Cancel_File_UploadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_file_upload = /** @type {((inputs?: Cancel_File_UploadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_File_UploadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancel_file_upload(inputs)
	if (locale === "de") return de_cancel_file_upload(inputs)
	if (locale === "it") return it_cancel_file_upload(inputs)
	if (locale === "ru") return ru_cancel_file_upload(inputs)
	if (locale === "es") return es_cancel_file_upload(inputs)
	if (locale === "zh-CN") return zh_cn2_cancel_file_upload(inputs)
	if (locale === "ja") return ja_cancel_file_upload(inputs)
	if (locale === "hi") return hi_cancel_file_upload(inputs)
	if (locale === "pt-PT") return pt_pt2_cancel_file_upload(inputs)
	return en_cancel_file_upload(inputs)
});